import React, { useState, useEffect} from "react";
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/admin/Breadcrumb';
import ModalPopup from 'components/modal/';
import Button from 'components/buttons/';
import UICheckbox from 'components/checkbox/UICheckbox';
import UIInput from 'components/input/input';
import { useHistory } from 'react-router-dom';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import UIUtils from "utils/UIUtils";
import UI from "components/UI";
import paramStore from "common/page/store/ParamStore";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import PageLoading from "../../../../components/loading";
import message from "common/message/source/MessageSource";
function ContentsContainer() {
	//const location = useLocation();
	const receivedData = paramStore.getParam("adm1406");
  	//const receivedData = (location.state as any)?.data;
  	const history = useHistory();
	
	const [SUB_YN, setSUB_YN] = useState('');
	const [PAY_REQ_STS_CD, setPAY_REQ_STS_CD] = useState('');
	const [CLO_YN, setCLO_YN] = useState('');

	const [OPR_AMT_GIV_RATE, setOPR_AMT_GIV_RATE] = useState('');
	const [PAY_REQ_NO_DISP, setPAY_REQ_NO_DISP] = useState('');
	const [PAY_REQ_STS_CD_DISP, setPAY_REQ_STS_CD_DISP] = useState('');
	const [SUB_YN_DISP, setSUB_YN_DISP] = useState('');
	const [PAY_REQ_DATE, setPAY_REQ_DATE] = useState('');
	const [PAY_COMPL_DATE, setPAY_COMPL_DATE] = useState('');
	const [ELEC_APPR_YN, setELEC_APPR_YN] = useState('');
		
	const [TSK_NM, setTSK_NM] = useState('');
	const [TSK_REQ_NO_DISP, setTSK_REQ_NO_DISP] = useState('');
	const [TSK_DATE, setTSK_DATE] = useState('');
	const [BIZ_NM, setBIZ_NM] = useState('');
	const [FUN_PUR_USE_NM, setFUN_PUR_USE_NM] = useState('');
	const [BIZ_KIND_NM1, setBIZ_KIND_NM1] = useState('');
	const [BIZ_KIND_NM2, setBIZ_KIND_NM2] = useState('');
	const [BIZ_KIND_NM3, setBIZ_KIND_NM3] = useState('');
	const [PERF_NM, setPERF_NM] = useState('');
	const [FORE_PAY_YN, setFORE_PAY_YN] = useState('');
	const [TOT_AMT, setTOT_AMT] = useState('');
	const [TOT_AMT_D, setTOT_AMT_D] = useState('');
	const [PERF_CNT, setPERF_CNT] = useState('');
	const [SUPP_CORP_CNT, setSUPP_CORP_CNT] = useState('');
	const [SUM_SUPP_CORP_AMT, setSUM_SUPP_CORP_AMT] = useState('');
	const [SUM_SUPP_CORP_AMT_D, setSUM_SUPP_CORP_AMT_D] = useState('');
	const [SUM_PERF_AMT, setSUM_PERF_AMT] = useState('');
	const [SUM_PERF_AMT_D, setSUM_PERF_AMT_D] = useState('');

	const [TRAN_CONT_YN, setTRAN_CONT_YN] = useState('');
	const [NOR_CNT, setNOR_CNT] = useState('');
	const [NOR_AMT, setNOR_AMT] = useState('');
	const [NOR_AMT_D, setNOR_AMT_D] = useState('');
	const [NON_CNT, setNON_CNT] = useState('');
	const [NON_AMT, setNON_AMT] = useState('');
	const [NON_AMT_D, setNON_AMT_D] = useState('');

	const [suppCont,setSuppCont] = useState(''); //지원내용, 과제개요 // as-is, to-be
	const [exeEffDesc,setExeEffDesc] = useState(''); //기대효과, 정성내용 // as-is, to-be
	const [qList,setQList] = useState({ //기대효과 14문항
		q1: '', q2: '', q3: '', q4: '', q5: '', q6: '', q7: '',
		q8: '', q9: '', q10: '', q11: '', q12: '', q13: '', q14: ''
	});			
	const [PAY_REQ_JUDGE_C, setPAY_REQ_JUDGE_C] = useState([]);
	const [PAY_REQ_JUDGE_D, setPAY_REQ_JUDGE_D] = useState([]);
	const [PAY_REQ_JUDGE, setPAY_REQ_JUDGE] = useState([]);
	
	const [CORP_NM, setCORP_NM] = useState('');
	const [BIZ_NO, setBIZ_NO] = useState('');
	const [CORP_REG_NO, setCORP_REG_NO] = useState('');
	const [PERSON_NM, setPERSON_NM] = useState('');
	const [POSI_NM, setPOSI_NM] = useState('');
	const [DEPT_NM, setDEPT_NM] = useState('');
	const [EMAIL_ADRES, setEMAIL_ADRES] = useState('');
	const [OFC_TEL_NO, setOFC_TEL_NO] = useState('');

	const [TOT_AMT_M, setTOT_AMT_M] = useState('');
	const [NOR_AMT_M, setNOR_AMT_M] = useState('');

	const [modal1520pIsOpen, setmodal1520pIsOpen] = useState(false);
	const [modal1521pIsOpen, setmodal1521pIsOpen] = useState(false);
	const [modal1408pIsOpen, setmodal1408pIsOpen] = useState(false);
	const [modal1409pIsOpen, setmodal1409pIsOpen] = useState(false);
	const [modal1410pIsOpen, setmodal1410pIsOpen] = useState(false);
	const [modal1411pIsOpen, setmodal1411pIsOpen] = useState(false);
	const [modal1415pIsOpen, setmodal1415pIsOpen] = useState(false);
	const [modal1211pIsOpen, setmodal1211pIsOpen] = useState(false);
	const [modal1307pIsOpen, setmodal1307pIsOpen] = useState(false);

	const [totalRowCnt, setTotalRowCnt] = useState(0);
	const [TotalRowCnt_1409p, setTotalRowCnt_1409p] = useState(0);

	const [Email_YN, setEmail_YN] = useState(false);
	const [JUDGE_CMT, setJUDGE_CMT] = useState('');
	
	const [fileValue_tmp] = useState(new TbComFile());
	const fileValue = React.useDeferredValue(fileValue_tmp);
	//const fileValue = React.useDeferredValue(fileValue_tmp);
	//const [fileValue_Pop] = useState(new TbComFile());

	const [fileValue_PRF] = useState(new TbComFile());
	const [fileValue_APRF] = useState(new TbComFile());
	//const [fileValuePop] = useState(new TbComFile());
	
	const [fileValue_TAX_tmp, SetfileValue_TAX_tmp] = useState(new TbComFile());
	const fileValue_TAX = React.useDeferredValue(fileValue_TAX_tmp);
	
	const [inputFileValue, setInputFileValue] = React.useState<TbComFile>(new TbComFile());
	//const fileValue_PRF = React.useDeferredValue(fileValue_PRF_tmp);
	//const fileValue_APRF = React.useDeferredValue(fileValue_APRF_tmp);
	
	const [loadFinish, setLoadFinish] = useState(false);

	const [fileInfoUploadList, setFileInfoUploadList] = React.useState<any[]>([]);  //파일업로드 리스트
	const [fileInfoUploadList_TAX, setFileInfoUploadList_TAX] = React.useState<any[]>([]);  //파일업로드 리스트
	//---파일업로드 
	const [uploadId, setUploadId] = React.useState("");
	const [uploadId_TAX, setUploadId_TAX] = React.useState("");
	
	const [FILE_ID, setFILE_ID] = React.useState("");
	const [FormCheck,setFormCheck] = useState(false);
	const [TaxFormCheck,setTaxFormCheck] = useState(false);
	  				
    async function initialize() {
		const response:any = await CommonUtil.execute({
            url:"adm_1406_r001",
            data: {
				"PAY_REQ_NO": receivedData.vPAY_REQ_NO,
			}
        })
    	.then((response: any) => {
			console.log(response);
			setOPR_AMT_GIV_RATE(response.OPR_AMT_GIV_RATE);
	        setPAY_REQ_NO_DISP(response.PAY_REQ_NO_DISP);
	        setSUB_YN_DISP(response.SUB_YN_DISP);
	        setPAY_REQ_STS_CD_DISP(response.PAY_REQ_STS_CD_DISP);
	        setPAY_REQ_DATE(response.PAY_REQ_DATE);
	        setPAY_COMPL_DATE(response.PAY_COMPL_DATE);
	        setELEC_APPR_YN(response.ELEC_APPR_YN);

	        setSUB_YN(response.SUB_YN);
	        setPAY_REQ_STS_CD(response.PAY_REQ_STS_CD);
	        setCLO_YN(response.CLO_YN);
	        
			setTSK_NM(response.TSK_NM);
			setTSK_REQ_NO_DISP(response.TSK_REQ_NO_DISP);
			setTSK_DATE(response.TSK_DATE);
			setBIZ_NM(response.BIZ_NM);
			setFUN_PUR_USE_NM(response.FUN_PUR_USE_NM);
			setPERF_NM(response.PERF_NM);
			setFORE_PAY_YN(response.FORE_PAY_YN);
			setBIZ_KIND_NM1(response.BIZ_KIND_NM1);
			setBIZ_KIND_NM2(response.BIZ_KIND_NM2);
			setBIZ_KIND_NM3(response.BIZ_KIND_NM3);
			setTOT_AMT(response.TOT_AMT);
			setTOT_AMT_D(response.TOT_AMT_D);
			setSUPP_CORP_CNT(response.SUPP_CORP_CNT);
			setSUM_SUPP_CORP_AMT(response.SUM_SUPP_CORP_AMT);
			setSUM_SUPP_CORP_AMT_D(response.SUM_SUPP_CORP_AMT_D);
			setPERF_CNT(response.PERF_CNT);
			setSUM_PERF_AMT(response.SUM_PERF_AMT);
			setSUM_PERF_AMT_D(response.SUM_PERF_AMT_D);
			
			//수행기업 갯수 및 집행완료 상태 확인하여 Y/N 
			setTRAN_CONT_YN(response.TRAN_CONT_YN);
			setNOR_CNT(response.NOR_CNT);
			setNOR_AMT(response.NOR_AMT);
			setNOR_AMT_D(response.NOR_AMT_D);
			setNON_CNT(response.NON_CNT);
			setNON_AMT(response.NON_AMT);
			setNON_AMT_D(response.NON_AMT_D);
			
			
			let question = response.QUESTION;
			if(question != null){
				let list = question.split('^||^');
				let qJson = {...qList};
				for(let i = 0; i < list.length; i++){
					qJson['q'+(i+1)] = list[i];
				}
				setQList(qJson);
			}
			
			let vfileInfoList = response.FILE_INFO_LIST;
			//PRF 지급신청서
			//APRF 선지급요청서
			//TAX 세금계산서
			
			if(vfileInfoList!= null){
				vfileInfoList?.forEach((item, index) => {
					const fileDetail = new TbComFileMapngDetail();
					fileDetail.setDwldId(item.DWLD_ID);
					fileDetail.setFileDetailId(item.FILE_DETAIL_ID);
					fileDetail.setFilePolicy(item.FILE_POLICY);
					fileDetail.setFileRpstr(item.FILE_RPSTR);
					fileDetail.setStrePath(item.STRE_PATH);
					fileDetail.setStreFileNm(item.STRE_FILE_NM);
					fileDetail.setOrginlFileNm(item.ORGINL_FILE_NM);
					fileDetail.setFileExtsn(item.FILE_EXTSN);
					fileDetail.setFileSize(Number(item.FILE_SIZE));
					fileDetail.setRegistDt(item.REGIST_DT);
					fileDetail.setRegistPsnNm(item.REGIST_PSN_NM);
					if (item.FILE_GB === 'PRF'){
						fileValue_PRF.putTbComFileMapngDetailList(fileDetail);
					} else if (item.FILE_GB === 'APRF'){
						fileValue_APRF.putTbComFileMapngDetailList(fileDetail);
					} else if (item.FILE_GB !== 'TAX'){
						fileValue_tmp.putTbComFileMapngDetailList(fileDetail);
					}
				})
			}
			
			/*
			fileValuePop.setTbComFileMapngDetailList([]);
			if(vfileInfoList!= null){
				vfileInfoList?.forEach((item, index) => {
					const fileDetail = new TbComFileMapngDetail();
					fileDetail.setDwldId(item.DWLD_ID);
					fileDetail.setFileDetailId(item.FILE_DETAIL_ID);
					fileDetail.setFilePolicy(item.FILE_POLICY);
					fileDetail.setFileRpstr(item.FILE_RPSTR);
					fileDetail.setStrePath(item.STRE_PATH);
					fileDetail.setStreFileNm(item.STRE_FILE_NM);
					fileDetail.setOrginlFileNm(item.ORGINL_FILE_NM);
					fileDetail.setFileExtsn(item.FILE_EXTSN);
					fileDetail.setFileSize(Number(item.FILE_SIZE));
					fileDetail.setRegistDt(item.REGIST_DT);
					fileDetail.setRegistPsnNm(item.REGIST_PSN_NM);
					if (item.FILE_GB === 'PRF'){
						//fileValue_PRF.putTbComFileMapngDetailList(fileDetail);
					} else if (item.FILE_GB === 'APRF'){
						//fileValue_APRF.putTbComFileMapngDetailList(fileDetail);
					} else if (item.FILE_GB !== 'TAX'){
						fileValuePop.putTbComFileMapngDetailList(fileDetail);
					}
				})
			}
			*/
			let vfileInfoList_TAX = response.FILE_INFO_LIST_TAX;
			
			//fileValue_TAX_tmp.setTbComFileMapngDetailList([]);
			if(vfileInfoList_TAX!= null){
				vfileInfoList_TAX?.forEach((item, index) => {
					const fileDetail = new TbComFileMapngDetail();
					fileDetail.setDwldId(item.DWLD_ID);
					fileDetail.setFileDetailId(item.FILE_DETAIL_ID);
					fileDetail.setFilePolicy(item.FILE_POLICY);
					fileDetail.setFileRpstr(item.FILE_RPSTR);
					fileDetail.setStrePath(item.STRE_PATH);
					fileDetail.setStreFileNm(item.STRE_FILE_NM);
					fileDetail.setOrginlFileNm(item.ORGINL_FILE_NM);
					fileDetail.setFileExtsn(item.FILE_EXTSN);
					fileDetail.setFileSize(Number(item.FILE_SIZE));
					fileDetail.setRegistDt(item.REGIST_DT);
					fileDetail.setRegistPsnNm(item.REGIST_PSN_NM);
					fileValue_TAX_tmp.putTbComFileMapngDetailList(fileDetail);
				})
			}
			
			setLoadFinish(true);

			setSuppCont(response.SUPP_CONT);
			setExeEffDesc(response.EXE_EFF_DESC);
			
			setPAY_REQ_JUDGE_C(response.REC1);
			setPAY_REQ_JUDGE_D(response.REC2);
			setPAY_REQ_JUDGE(response.REC3);
			
	        setCORP_NM(response.CORP_NM);
	        setBIZ_NO(response.BIZ_NO);
	        setCORP_REG_NO(response.CORP_REG_NO);
	        setPERSON_NM(response.PERSON_NM);
	        setPOSI_NM(response.POSI_NM);
	        setDEPT_NM(response.DEPT_NM);
	        setEMAIL_ADRES(response.EMAIL_ADRES);
	        setOFC_TEL_NO(response.OFC_TEL_NO);
			setFILE_ID(response.FILE_ID);

       	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	         

	}

    async function onClickList() {
	    let dataToSend = {};
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
	      pathname: './adm1405',
	      state: { data: dataToSend }
	    });

    };
    	
    const formatNewLines = (text) => {
	    if (!text) {
	        return;
	    }		
	    
        return text.split('\n').map((item, index) => (
            <React.Fragment key={index}>
                {item}
                <br />
            </React.Fragment>
        ));
    };
	
    let SheetData = {};
    let totalCnt:number = 0;
	//let defaultRowCnt = 10;

 	var ib_1410p = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				//"SearchMode": 1,
				//"PageLength": defaultRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate": "0",
				"CustomScroll": "1", 	
				"HeaderMerge": 4,
				"ShowFilter": 1,
				"Down2ExcelConfig" : {
    				"sheetDesign":1,
    				"merge":1
  				}	
			},

			"Def": {
			    "Row": {
			      "CanFormula": true,
			      "CalcOrder": "Deposit_ReceiptVisible",
		    	},
    		},			
			
			"Cols": [
	            {"Header": ["기금지원내역","지원기업"],				"Type": "Text",	"Name": "SUPP_CORP_NM",			"RelWidth": 1,		"Align": "left",	"CanEdit": 0},
	            {"Header": ["기금지원내역","사업자등록번호"],			"Type": "Text",	"Name": "SUPP_BIZ_NO_DISP",		"RelWidth": 1,		"Align": "Center", 	"CanEdit": 0},
	            {"Header": ["기금지원내역","지원금액(원)"],				"Type": "Text",	"Name": "PAY_AMT",				"RelWidth": 1,		"Align": "Right", 	"CanEdit": 0},
	            {"Header": ["중소기업 지급 계좌 정보","대표자명"],		"Type": "Text",	"Name": "SUPP_CEO_NM",			"RelWidth": 1,		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["중소기업 지급 계좌 정보","특수관계인\n여부"],	"Type": "Text",	"Name": "SPC_RELATE_PERSON_YN",	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["중소기업 지급 계좌 정보","지급은행"],		"Type": "Text",	"Name": "SUPP_ACC_BANK_NM",		"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["중소기업 지급 계좌 정보","지급계좌"],		"Type": "Text",	"Name": "SUPP_ACC_NO",			"RelWidth": 1, 		"Align": "left",	"CanEdit": 0},
	            {"Header": ["중소기업 지급 계좌 정보","예금주"],			"Type": "Text",	"Name": "SUPP_ACC_HOLDER",		"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["중소기업 지급 계좌 정보","수취인"],			"Type": "Text",	"Name": "FIND_REF_NM"	,		"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["집행내역","집행금액(원)"],				"Type": "Text",	"Name": "TRAN_AMT",				"RelWidth": 1, 		"Align": "Right",	"CanEdit": 0},
	            {"Header": ["집행내역","집행일시"],					"Type": "Text",	"Name": "TRAN_DATETIME",		"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["집행내역","집행상태"],					"Type": "Text",	"Name": "ERR_MESSAGE",			"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {
					"Header": ["집행내역","입금확인"],
					"Type": "Button",
					"Name": "Deposit_Receipt",
					"RelWidth": 1,
					"Align": "Center",
					"CanEdit": 0,
					"DefaultValue": "출력",
					VisibleFormula:function(fr){
						if(fr.Row["PROC_STS"] === "0000"){
					    	return 1;
				      	} else if( fr.Row["PROC_STS"] === undefined){
							return 0;
						} else {
							return 0;
						}
					}							
				},
	            {"Header": "PROC_STS",							"Type": "Text",	"Name": "PROC_STS",				"RelWidth": 0,	Visible : 0},
				{"Header": "REG_DATE",							"Type": "Text",	"Name": "REG_DATE",				"RelWidth": 0, 	Visible : 0},
				{"Header": "REG_NUM",							"Type": "Text",	"Name": "REG_NUM",				"RelWidth": 0, 	Visible : 0},
				{"Header": "REG_SEQ",							"Type": "Text",	"Name": "REG_SEQ",				"RelWidth": 0, 	Visible : 0},
	            
            ],      

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				var sheet = evtParam.sheet;
				sheet.setMergeRange( sheet.getRowById("HR1"), "PAY_AMT", sheet.getRowById("Filter"), "PAY_AMT");
				sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_CEO_NM", sheet.getRowById("Filter"), "SUPP_CEO_NM");
				sheet.setMergeRange( sheet.getRowById("HR1"), "SPC_RELATE_PERSON_YN", sheet.getRowById("Filter"), "SPC_RELATE_PERSON_YN");
				sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_ACC_BANK_NM", sheet.getRowById("Filter"), "SUPP_ACC_BANK_NM");
				sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_ACC_NO", sheet.getRowById("Filter"), "SUPP_ACC_NO");
				sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_ACC_HOLDER", sheet.getRowById("Filter"), "SUPP_ACC_HOLDER");
				sheet.setMergeRange( sheet.getRowById("HR1"), "FIND_REF_NM", sheet.getRowById("Filter"), "FIND_REF_NM");
				sheet.setMergeRange( sheet.getRowById("HR1"), "TRAN_AMT", sheet.getRowById("Filter"), "TRAN_AMT");
				sheet.setMergeRange( sheet.getRowById("HR1"), "TRAN_DATETIME", sheet.getRowById("Filter"), "TRAN_DATETIME");
				sheet.setMergeRange( sheet.getRowById("HR1"), "ERR_MESSAGE", sheet.getRowById("Filter"), "ERR_MESSAGE");
				sheet.setMergeRange( sheet.getRowById("HR1"), "Deposit_Receipt", sheet.getRowById("Filter"), "Deposit_Receipt");
				
				init_1410p();
			},
			onClick:function (args) {
  				if (args.col === 'Deposit_Receipt' && args.row.PROC_STS === '0000' ){
					var vREG_DATE = args.row.REG_DATE;
					var vREG_NUM = args.row.REG_NUM;
					var vREG_SEQ = args.row.REG_SEQ;
					
				    UIUtils.openOZReportViewerPopup({
				        title: "입금확인증",
				        reportName: "Deposit_receipt",
				        parameter: {
							"odi.odinames": "Deposit_receipt",
							"odi.Deposit_receipt.pcount": "3",
							"odi.Deposit_receipt.args1": "reg_date=" + vREG_DATE,
							"odi.Deposit_receipt.args2": "reg_num=" + vREG_NUM,
							"odi.Deposit_receipt.args3": "reg_seq=" + vREG_SEQ,
					        "information.debug":"true", // 콘솔정보(Ctrl+Z) 표시 여부
					        // "toolbar.first":"true", // 첫페이지 이동 아이콘 표시
					        // "toolbar.last":"true", // 마지막페이지 이동 아이콘 표시
					
					        "pdf.fontembedding":"true", // PDF 폰트포함 (글꼴 깨지는것 방지)
					        "pdf.fontembedding_subset":"true", // 폰트의 서브셋을 저장할지 여부
					
					        "export.format":"pdf", // 저장포맷
					        "export.filename": "입금확인증" + ".pdf", // 파일명
					        "export.mode":"silent", // 설정창 보여줄지 여부
					
					        "viewer.pagedisplay":"continuous", // 페이지 표시 옵션
					        "viewer.viewmode":"normal", // 보고서 보기 모드
					        "viewer.zoom": "90"         
						},
				        onClose: () => {
				            console.log("Report Viewer Close");
				        }
				    })					
				}
  			}			
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet_modal', // 생성할 시트의 id
				el: 'tb_cfms_pay_req_amt_s', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: SheetData // 생성될 시트의 정적데이터

			});
			// global 변수 선언
			//@ts-ignore
		},

		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet_modal.down2Excel({fileName: "지원기업목록_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},

	}
	
    async function init_1410p() {
		const response:any = await CommonUtil.execute({
            url:"adm_1406_r002",
            data: {
				"PAY_REQ_NO": receivedData.vPAY_REQ_NO,
				"SUPP_TP_CD": "S",
			}
			
        })
    	.then((response: any) => {
			totalCnt = Object.keys(response.REC).length;
			setTotalRowCnt(totalCnt);
			
			setTOT_AMT_M(response.TOT_AMT);
			setNOR_AMT_M(response.NOR_AMT);
			
			SheetData = response.REC;
			// @ts-ignore
	        sheet_modal.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	        // @ts-ignore
	        sheet_modal.loadSearchData(SheetData);
	        // @ts-ignore
					
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	 
    	
	}
	
	
    async function onAfterOpen1410p() {
        ib_1410p.create();
        
		return () => {
	      // @ts-ignore
	    	IBSheet.disposeAll(true);
	    }            
	
	}


 	var ib_1411p = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				//"SearchMode": 1,
				//"PageLength": defaultRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"CustomScroll": "1",	
				"HeaderMerge": 4,
				"ShowFilter": 1,
				"Down2ExcelConfig" : {
    				"sheetDesign":1,
    				"merge":1
  				}	
			},
			
			"Def": {
			    "Row": {
			      "CanFormula": true,
			      "CalcOrder": "Deposit_ReceiptVisible",
		    	},
    		},			
			
			
			"Cols": [
	            {"Header": ["기금지원내역","수행기업"],				"Type": "Text",	"Name": "SUPP_CORP_NM",			"RelWidth": 1,		"Align": "left",	"CanEdit": 0},
	            {"Header": ["기금지원내역","사업자등록번호"],			"Type": "Text",	"Name": "SUPP_BIZ_NO_DISP",		"RelWidth": 1,		"Align": "Center", 	"CanEdit": 0},
	            {"Header": ["기금지원내역","지원금액(원)"],				"Type": "Text",	"Name": "PAY_AMT",				"RelWidth": 1,		"Align": "Right", 	"CanEdit": 0},
	            {"Header": ["수행기업 지급 계좌 정보","대표자명"],		"Type": "Text",	"Name": "SUPP_CEO_NM",			"RelWidth": 1,		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["수행기업 지급 계좌 정보","특수관계인\n여부"],	"Type": "Text",	"Name": "SPC_RELATE_PERSON_YN",	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["수행기업 지급 계좌 정보","지급은행"],		"Type": "Text",	"Name": "SUPP_ACC_BANK_NM",		"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["수행기업 지급 계좌 정보","지급계좌"],		"Type": "Text",	"Name": "SUPP_ACC_NO",			"RelWidth": 1, 		"Align": "left",	"CanEdit": 0},
	            {"Header": ["수행기업 지급 계좌 정보","부가세포함여부"],	"Type": "Text",	"Name": "VAT_YN",				"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["수행기업 지급 계좌 정보","예금주"],			"Type": "Text",	"Name": "SUPP_ACC_HOLDER",		"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["수행기업 지급 계좌 정보","수취인"],			"Type": "Text",	"Name": "FIND_REF_NM"	,		"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["집행내역","집행금액(원)"],				"Type": "Text",	"Name": "TRAN_AMT",				"RelWidth": 1, 		"Align": "Right",	"CanEdit": 0},
	            {"Header": ["집행내역","집행일시"],					"Type": "Text",	"Name": "TRAN_DATETIME",		"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["집행내역","집행상태"],					"Type": "Text",	"Name": "ERR_MESSAGE",			"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {
					"Header": ["집행내역","입금확인"],
					"Type": "Button",
					"Name": "Deposit_Receipt",
					"RelWidth": 1,
					"Align": "Center",
					"CanEdit": 0,
					"DefaultValue": "출력",
					"Button": "Button",
					VisibleFormula:function(fr){
						if(fr.Row["PROC_STS"] === "0000"){
					    	return 1;
				      	} else if( fr.Row["PROC_STS"] === undefined){
							return 0;
						} else {
							return 0;
						}
					}							
				},
	            {"Header": ["집행내역","예금주조회"],					"Type": "Button", "Name": "FIND_REF",		"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0, "DefaultValue": "조회", "Button": "Button"},
				{"Header": "PROC_STS",							"Type": "Text",	"Name": "PROC_STS",				"RelWidth": 0, 	Visible : 0},
				{"Header": "REG_DATE",							"Type": "Text",	"Name": "REG_DATE",				"RelWidth": 0, 	Visible : 0},
				{"Header": "REG_NUM",							"Type": "Text",	"Name": "REG_NUM",				"RelWidth": 0, 	Visible : 0},
				{"Header": "REG_SEQ",							"Type": "Text",	"Name": "REG_SEQ",				"RelWidth": 0, 	Visible : 0},
				
				
            ],      

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				var sheet = evtParam.sheet;
				sheet.setMergeRange( sheet.getRowById("HR1"), "PAY_AMT", sheet.getRowById("Filter"), "PAY_AMT");
				sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_CEO_NM", sheet.getRowById("Filter"), "SUPP_CEO_NM");
				sheet.setMergeRange( sheet.getRowById("HR1"), "SPC_RELATE_PERSON_YN", sheet.getRowById("Filter"), "SPC_RELATE_PERSON_YN");
				sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_ACC_BANK_NM", sheet.getRowById("Filter"), "SUPP_ACC_BANK_NM");
				sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_ACC_NO", sheet.getRowById("Filter"), "SUPP_ACC_NO");
				sheet.setMergeRange( sheet.getRowById("HR1"), "VAT_YN", sheet.getRowById("Filter"), "VAT_YN");
				sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_ACC_HOLDER", sheet.getRowById("Filter"), "SUPP_ACC_HOLDER");
				sheet.setMergeRange( sheet.getRowById("HR1"), "FIND_REF_NM", sheet.getRowById("Filter"), "FIND_REF_NM");
				sheet.setMergeRange( sheet.getRowById("HR1"), "TRAN_AMT", sheet.getRowById("Filter"), "TRAN_AMT");
				sheet.setMergeRange( sheet.getRowById("HR1"), "TRAN_DATETIME", sheet.getRowById("Filter"), "TRAN_DATETIME");
				sheet.setMergeRange( sheet.getRowById("HR1"), "ERR_MESSAGE", sheet.getRowById("Filter"), "ERR_MESSAGE");
				sheet.setMergeRange( sheet.getRowById("HR1"), "Deposit_Receipt", sheet.getRowById("Filter"), "Deposit_Receipt");
				sheet.setMergeRange( sheet.getRowById("HR1"), "FIND_REF", sheet.getRowById("Filter"), "FIND_REF");
				init_1411p();
			},
			onClick:function (args) {
  				if (args.col === 'Deposit_Receipt' && args.row.PROC_STS === '0000' ){
					var vREG_DATE = args.row.REG_DATE;
					var vREG_NUM = args.row.REG_NUM;
					var vREG_SEQ = args.row.REG_SEQ;
					
				    UIUtils.openOZReportViewerPopup({
				        title: "입금확인증",
				        reportName: "Deposit_receipt",
				        parameter: {
							"odi.odinames": "Deposit_receipt",
							"odi.Deposit_receipt.pcount": "3",
							"odi.Deposit_receipt.args1": "reg_date=" + vREG_DATE,
							"odi.Deposit_receipt.args2": "reg_num=" + vREG_NUM,
							"odi.Deposit_receipt.args3": "reg_seq=" + vREG_SEQ,
					        "information.debug":"true", // 콘솔정보(Ctrl+Z) 표시 여부
					        // "toolbar.first":"true", // 첫페이지 이동 아이콘 표시
					        // "toolbar.last":"true", // 마지막페이지 이동 아이콘 표시
					
					        "pdf.fontembedding":"true", // PDF 폰트포함 (글꼴 깨지는것 방지)
					        "pdf.fontembedding_subset":"true", // 폰트의 서브셋을 저장할지 여부
					
					        "export.format":"pdf", // 저장포맷
					        "export.filename": "입금확인증" + ".pdf", // 파일명
					        "export.mode":"silent", // 설정창 보여줄지 여부
					
					        "viewer.pagedisplay":"continuous", // 페이지 표시 옵션
					        "viewer.viewmode":"normal", // 보고서 보기 모드
					        "viewer.zoom": "90"         
						},
				        onClose: () => {
				            console.log("Report Viewer Close");
				        }
				    })					
				} else if (args.col === 'FIND_REF'){
					var aREG_DATE = args.row.REG_DATE;
					var aREG_NUM = args.row.REG_NUM;
					var aREG_SEQ = args.row.REG_SEQ;
					console.log('aREG_DATE = ' + aREG_DATE);
					console.log('aREG_NUM = ' + aREG_NUM);
					console.log('aREG_SEQ = ' + aREG_SEQ);
										
					OnClickFindRefNM(aREG_DATE, aREG_NUM, aREG_SEQ);
					
				}
				
  			}
  			
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet_modal', // 생성할 시트의 id
				el: 'tb_cfms_pay_req_amt_p', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: SheetData // 생성될 시트의 정적데이터

			});
			// global 변수 선언
			//@ts-ignore
		},

		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet_modal.down2Excel({fileName: "수행기업목록_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},

	}


    async function init_1411p() {
		const response:any = await CommonUtil.execute({
            url:"adm_1406_r002",
            data: {
				"PAY_REQ_NO": receivedData.vPAY_REQ_NO,
				"SUPP_TP_CD": "P",
			}
			
        })
    	.then((response: any) => {
			totalCnt = Object.keys(response.REC).length;
			setTotalRowCnt(totalCnt);
	
			setTOT_AMT_M(response.TOT_AMT);
			setNOR_AMT_M(response.NOR_AMT);

			SheetData = response.REC;
			// @ts-ignore
	        sheet_modal.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	        // @ts-ignore
	        sheet_modal.loadSearchData(SheetData);
	        // @ts-ignore
					
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	 
    	
	}
			        	
    async function OnClickFindRefNM(sREG_DATE:string, sREG_NUM:string, sREG_SEQ:string) {
		console.log('sREG_DATE = ' + sREG_DATE);
		console.log('sREG_NUM = ' + sREG_NUM);
		console.log('sREG_SEQ = ' + sREG_SEQ);
		const response:any = await CommonUtil.execute({
            url:"adm_1406_u010",
            data: {
				"REG_DATE": sREG_DATE,
				"REG_NUM": sREG_NUM,
				"REG_SEQ": sREG_SEQ,
			}
			
        })
    	.then((response: any) => {
			init_1411p();
											
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	 
    	
	}
				        	
    async function onAfterOpen1411p() {
        ib_1411p.create();
        
		return () => {
	      // @ts-ignore
	    	IBSheet.disposeAll(true);
	    }            
	
	}
	
	
 	var ib_1415p = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				//"SearchMode": 1,
				//"PageLength": defaultRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"CustomScroll": "1",
				"HeaderMerge": 4,
				"ShowFilter": 1,	

			},
			
			"Cols": [
	            {"Header": ["기금지원내역","지원기업"],			"Type": "Text",	"Name": "SUPP_CORP_NM",			"RelWidth": 1,		"Align": "left",	"CanEdit": 0},
	            {"Header": ["기금지원내역","사업자등록번호"],		"Type": "Text",	"Name": "SUPP_BIZ_NO_DISP",		"RelWidth": 1,		"Align": "Center", 	"CanEdit": 0},
	            {"Header": ["기금지원내역","지원금액(원)"],			"Type": "Text",	"Name": "PAY_AMT",				"RelWidth": 1,		"Align": "Right", 	"CanEdit": 0},
	            {"Header": ["중소기업 지급 계좌 정보","대표자명"],	"Type": "Text",	"Name": "SUPP_CEO_NM",			"RelWidth": 1,		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["중소기업 지급 계좌 정보","지급은행"],	"Type": "Text",	"Name": "SUPP_ACC_BANK_NM",		"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["중소기업 지급 계좌 정보","지급계좌"],	"Type": "Text",	"Name": "SUPP_ACC_NO",			"RelWidth": 1, 		"Align": "left",	"CanEdit": 0},
	            {"Header": ["중소기업 지급 계좌 정보","예금주"],		"Type": "Text",	"Name": "SUPP_ACC_HOLDER",		"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["중소기업 지급 계좌 정보","수취인"],		"Type": "Text",	"Name": "FIND_REF_NM"	,		"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["집행내역","집행금액(원)"],			"Type": "Text",	"Name": "TRAN_AMT",				"RelWidth": 1, 		"Align": "Right",	"CanEdit": 0},
	            {"Header": ["집행내역","집행일시"],				"Type": "Text",	"Name": "TRAN_DATETIME",		"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": ["집행내역","집행상태"],				"Type": "Text",	"Name": "ERR_MESSAGE",			"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
            ],      

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				var sheet = evtParam.sheet;
				sheet.setMergeRange( sheet.getRowById("HR1"), "PAY_AMT", sheet.getRowById("Filter"), "PAY_AMT");
				sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_CEO_NM", sheet.getRowById("Filter"), "SUPP_CEO_NM");
				sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_ACC_BANK_NM", sheet.getRowById("Filter"), "SUPP_ACC_BANK_NM");
				sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_ACC_NO", sheet.getRowById("Filter"), "SUPP_ACC_NO");
				sheet.setMergeRange( sheet.getRowById("HR1"), "SUPP_ACC_HOLDER", sheet.getRowById("Filter"), "SUPP_ACC_HOLDER");
				sheet.setMergeRange( sheet.getRowById("HR1"), "FIND_REF_NM", sheet.getRowById("Filter"), "FIND_REF_NM");
				sheet.setMergeRange( sheet.getRowById("HR1"), "TRAN_AMT", sheet.getRowById("Filter"), "TRAN_AMT");
				sheet.setMergeRange( sheet.getRowById("HR1"), "TRAN_DATETIME", sheet.getRowById("Filter"), "TRAN_DATETIME");
				sheet.setMergeRange( sheet.getRowById("HR1"), "ERR_MESSAGE", sheet.getRowById("Filter"), "ERR_MESSAGE");

				init_1415p();
			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet_modal', // 생성할 시트의 id
				el: 'tb_cfms_pay_req_amt', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: SheetData // 생성될 시트의 정적데이터

			});
			// global 변수 선언
			//@ts-ignore
		},

		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet_modal.down2Excel({fileName: "지원기업목록(운영비)_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
			
		},

	}
	
	
    async function init_1415p() {
		const response:any = await CommonUtil.execute({
            url:"adm_1406_r002",
            data: {
				"PAY_REQ_NO": receivedData.vPAY_REQ_NO,
				"SUPP_TP_CD": "S",
			}
			
        })
    	.then((response: any) => {
			totalCnt = Object.keys(response.REC).length;
			setTotalRowCnt(totalCnt);

			setTOT_AMT_M(response.TOT_AMT);
			setNOR_AMT_M(response.NOR_AMT);
	
			SheetData = response.REC;
			// @ts-ignore
	        sheet_modal.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	        // @ts-ignore
	        sheet_modal.loadSearchData(SheetData);
			// @ts-ignore
					
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	 
    	
	}	
			        	

    async function onAfterOpen1415p() {
        ib_1415p.create();
        
		return () => {
	      // @ts-ignore
	    	IBSheet.disposeAll(true);
	    }            
	
	}
				
 	var ib_1408p = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				//"SearchMode": 0,
				//"PageLength": defaultRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": 0,
				"Alternate": 0,
				"CustomScroll": 3,	
				"SectionCanResize": 1,
				"ShowFilter": 1,
				"HeaderCheck": 1,
				"HeaderCheckMode": 1,				
				
			},
			
			"LeftCols": [
	            {"Header": "NO",					"Type": "Text",	"Name": "SEQ",					"MinWidth": 50, 	"RelWidth": 1,		"Align": "Center",	"CanEdit": 0},
	            {
					"Header": {
						"Value": "",
						"HeaderCheck": 1, //헤더(Header)에 체크박스 생성
						"IconAlign": "Center" //체크박스 가운데 정렬
					},
					"Type" : "Bool",
					"Name": "chk",
					"MinWidth": 50,
					"RelWidth": 1,
					"Align": "Center",
					"CanEdit": 1,
					"CanSort": 0
	            	
	            },
	            {"Header": "지원기업명",            	"Type": "Text",	"Name": "SUPP_CORP_NM",        	"MinWidth": 100,   	"RelWidth": 1,     	"Align": "left",   	"CanEdit": 0,},
	            {"Header": "사업자등록번호",				"Type": "Text",	"Name": "SUPP_BIZ_NO",			"MinWidth": 120, 	"RelWidth": 1,		"Align": "Center", 	"CanEdit": 0,},
	            {"Header": "최종검증일시",				"Type": "Text",	"Name": "VERI_DATE",			"MinWidth": 160, 	"RelWidth": 1,		"Align": "Center", 	"CanEdit": 0,},
	            {"Header": "중소기업\n여부",			"Type": "Text",	"Name": "ENP_SZE_YN",			"MinWidth": 80, 	"RelWidth": 1,		"Align": "Center",	"CanEdit": 0,},
	            {"Header": "중소기업여부\n(담당자수정)",	"Type": "Text",	"Name": "SUPP_CORP_YN",			"MinWidth": 90, 	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0,},
	            {"Header": "특수관계인\n여부",			"Type": "Text",	"Name": "SPC_RELATE_PERSON_YN",	"MinWidth": 90, 	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0,},
	            {"Header": "지원금액(원)",				"Type": "Int",	"Name": "PAY_AMT",				"MinWidth": 100, 	"RelWidth": 1, 		"Align": "Right",	"CanEdit": 0, "Format": "#,###" },
			],
			
			"Cols": [
	            {"Header": "대표자",				"Type": "Text",	"Name": "NAME",					"MinWidth": 60, 	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "수취인",				"Type": "Text",	"Name": "FIND_REF_NM",			"MinWidth": 100, 	"RelWidth": 1, 		"Align": "left",	"CanEdit": 0},
	            {"Header": "기업명",				"Type": "Text",	"Name": "ENP_NM",				"MinWidth": 100, 	"RelWidth": 1, 		"Align": "left",	"CanEdit": 0},
	            {"Header": "기업규모",				"Type": "Text",	"Name": "ENP_SZE",				"MinWidth": 100, 	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "휴/폐업",				"Type": "Text",	"Name": "LQDT_CLS",				"MinWidth": 160, 	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "휴/폐업\n사유",			"Type": "Text",	"Name": "LQDT_RSN",				"MinWidth": 160, 	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "정식\n기업명",			"Type": "Text",	"Name": "ENP_NM_TRD",			"MinWidth": 100,	"RelWidth": 1, 		"Align": "left",	"CanEdit": 0},
	            {"Header": "소속\n그룹",			"Type": "Text",	"Name": "GRP_NM",				"MinWidth": 100,	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "종업\n원수",			"Type": "Int",	"Name": "ORDN_EM",				"MinWidth": 100,	"RelWidth": 1, 		"Align": "Right",	"CanEdit": 0, "Format": "#,###" },
	            {"Header": "업종\n코드",			"Type": "Text",	"Name": "BZC_CD",				"MinWidth": 100,	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "업태",				"Type": "Text",	"Name": "BZC_NM_L",				"MinWidth": 120,	"RelWidth": 1, 		"Align": "left",	"CanEdit": 0},
	            {"Header": "업종",				"Type": "Text",	"Name": "BZC_NM",				"MinWidth": 120,	"RelWidth": 1, 		"Align": "left",	"CanEdit": 0},
	            {"Header": "우편\n번호",			"Type": "Text",	"Name": "LOC_ZIP",				"MinWidth": 80,		"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "주소",				"Type": "Text",	"Name": "LOC_ADDRA",			"MinWidth": 200,	"RelWidth": 1, 		"Align": "left",	"CanEdit": 0},
	            {"Header": "상세주소",				"Type": "Text",	"Name": "LOC_ADDRB",			"MinWidth": 120,	"RelWidth": 1, 		"Align": "left",	"CanEdit": 0},
	            {"Header": "결산일자",				"Type": "Text",	"Name": "ACCT_EDDT",			"MinWidth": 100,	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "자본금(원)",			"Type": "Int",	"Name": "FUNDTOTAL",			"MinWidth": 100,	"RelWidth": 1, 		"Align": "Right",	"CanEdit": 0, "Format": "#,###" },
	            {"Header": "매출액(원)",			"Type": "Int",	"Name": "SALES",				"MinWidth": 100,	"RelWidth": 1, 		"Align": "Right",	"CanEdit": 0, "Format": "#,###" },
	            {"Header": "BIZ_NO",			"Type": "Text",	"Name": "BIZ_NO",				"RelWidth": 1, 		Visible : 0, 		"CanEdit": 0},
            ],      

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				var sheet = evtParam.sheet;
                //헤더행과 필터행 강제 머지
                sheet.setMergeRange( sheet.getRowById("Header"), "SEQ", sheet.getRowById("Filter"), "SEQ");
                sheet.setMergeRange( sheet.getRowById("Header"), "chk", sheet.getRowById("Filter"), "chk");
                sheet.setMergeRange( sheet.getRowById("Header"), "VERI_DATE", sheet.getRowById("Filter"), "VERI_DATE");
                sheet.setMergeRange( sheet.getRowById("Header"), "PAY_AMT", sheet.getRowById("Filter"), "PAY_AMT");
                sheet.setMergeRange( sheet.getRowById("Header"), "ENP_SZE_YN", sheet.getRowById("Filter"), "ENP_SZE_YN");
                sheet.setMergeRange( sheet.getRowById("Header"), "SUPP_CORP_YN", sheet.getRowById("Filter"), "SUPP_CORP_YN");
                sheet.setMergeRange( sheet.getRowById("Header"), "SPC_RELATE_PERSON_YN", sheet.getRowById("Filter"), "SPC_RELATE_PERSON_YN");
                sheet.setMergeRange( sheet.getRowById("Header"), "NAME", sheet.getRowById("Filter"), "NAME");
                sheet.setMergeRange( sheet.getRowById("Header"), "FIND_REF_NM", sheet.getRowById("Filter"), "FIND_REF_NM");
                sheet.setMergeRange( sheet.getRowById("Header"), "ENP_NM", sheet.getRowById("Filter"), "ENP_NM");
                sheet.setMergeRange( sheet.getRowById("Header"), "ENP_SZE", sheet.getRowById("Filter"), "ENP_SZE");
                sheet.setMergeRange( sheet.getRowById("Header"), "LQDT_CLS", sheet.getRowById("Filter"), "LQDT_CLS");
                sheet.setMergeRange( sheet.getRowById("Header"), "LQDT_RSN", sheet.getRowById("Filter"), "LQDT_RSN");
                sheet.setMergeRange( sheet.getRowById("Header"), "ENP_NM_TRD", sheet.getRowById("Filter"), "ENP_NM_TRD");
                sheet.setMergeRange( sheet.getRowById("Header"), "GRP_NM", sheet.getRowById("Filter"), "GRP_NM");
                sheet.setMergeRange( sheet.getRowById("Header"), "ORDN_EM", sheet.getRowById("Filter"), "ORDN_EM");
                sheet.setMergeRange( sheet.getRowById("Header"), "BZC_CD", sheet.getRowById("Filter"), "BZC_CD");
                sheet.setMergeRange( sheet.getRowById("Header"), "BZC_NM_L", sheet.getRowById("Filter"), "BZC_NM_L");
                sheet.setMergeRange( sheet.getRowById("Header"), "BZC_NM", sheet.getRowById("Filter"), "BZC_NM");
                sheet.setMergeRange( sheet.getRowById("Header"), "LOC_ZIP", sheet.getRowById("Filter"), "LOC_ZIP");
                sheet.setMergeRange( sheet.getRowById("Header"), "LOC_ADDRA", sheet.getRowById("Filter"), "LOC_ADDRA");
                sheet.setMergeRange( sheet.getRowById("Header"), "LOC_ADDRB", sheet.getRowById("Filter"), "LOC_ADDRB");
                sheet.setMergeRange( sheet.getRowById("Header"), "ACCT_EDDT", sheet.getRowById("Filter"), "ACCT_EDDT");
                sheet.setMergeRange( sheet.getRowById("Header"), "FUNDTOTAL", sheet.getRowById("Filter"), "FUNDTOTAL");
                sheet.setMergeRange( sheet.getRowById("Header"), "SALES", sheet.getRowById("Filter"), "SALES");
                sheet.setMergeRange( sheet.getRowById("Header"), "BIZ_NO", sheet.getRowById("Filter"), "BIZ_NO");                				
				//초기 데이터 로딩
				init_1408p();
			},
			onDblClick:function(evtParam){
				setmodal1409pIsOpen(true)
		    },	
			
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet_modal', // 생성할 시트의 id
				el: 'tb_cfms_supp_corp_veri', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: SheetData // 생성될 시트의 정적데이터

			});
			// global 변수 선언
			//@ts-ignore
		},

		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet_modal.down2Excel({fileName: "지원기업검증_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
			
		},

	}
	
	
    async function init_1408p() {
		const response:any = await CommonUtil.execute({
            url:"adm_1406_r005",
            data: {
				"PAY_REQ_NO": receivedData.vPAY_REQ_NO,
			}
			
        })
    	.then((response: any) => {
			totalCnt = Object.keys(response.REC).length;
			setTotalRowCnt(totalCnt);

			SheetData = response.REC;
			// @ts-ignore
	        sheet_modal.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	        // @ts-ignore
	        sheet_modal.loadSearchData(SheetData);
			// @ts-ignore
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	 
    	
	}	
			        	

    async function onAfterOpen1408p() {
        ib_1408p.create();
        
		return () => {
	      // @ts-ignore
	    	IBSheet.disposeAll(true);
	    }            
	
	}				
	
    let SheetData_1409p = {};
    let totalCnt_1409p:number = 0;
	
 	var ib_1409p = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				//"SearchMode": 1,
				//"PageLength": defaultRowCnt,
				"AutoRowHeight" : 1,
				"InfoRowConfig" : "0",
				"Alternate" : "0",
				"CustomScroll" : 3,	
				"Height": "500px",

			},
			
			"Cols": [
	            {"Header": "검증일시",				"Type": "Text",	"Name": "VERI_DATE",			"MinWidth": 160, 	"RelWidth": 1,		"Align": "Center", 	"CanEdit": 0},
	            {"Header": "대표자",				"Type": "Text",	"Name": "NAME",					"MinWidth": 60, 	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "기업명",				"Type": "Text",	"Name": "ENP_NM",				"MinWidth": 100, 	"RelWidth": 1, 		"Align": "left",	"CanEdit": 0},
	            {"Header": "기업규모",				"Type": "Text",	"Name": "ENP_SZE",				"MinWidth": 100, 	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "휴/폐업",				"Type": "Text",	"Name": "LQDT_CLS",				"MinWidth": 160, 	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "휴/폐업 사유",			"Type": "Text",	"Name": "LQDT_RSN",				"MinWidth": 160, 	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "정식 기업명",			"Type": "Text",	"Name": "ENP_NM_TRD",			"MinWidth": 100,	"RelWidth": 1, 		"Align": "left",	"CanEdit": 0},
	            {"Header": "소속그룹",				"Type": "Text",	"Name": "GRP_NM",				"MinWidth": 100,	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "종업원수",				"Type": "Int",	"Name": "ORDN_EM",				"MinWidth": 100,	"RelWidth": 1, 		"Align": "Right",	"CanEdit": 0, "Format": "#,###" },
	            {"Header": "업종코드",				"Type": "Text",	"Name": "BZC_CD",				"MinWidth": 100,	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "업태",				"Type": "Text",	"Name": "BZC_NM_L",				"MinWidth": 120,	"RelWidth": 1, 		"Align": "left",	"CanEdit": 0},
	            {"Header": "업종",				"Type": "Text",	"Name": "BZC_NM",				"MinWidth": 120,	"RelWidth": 1, 		"Align": "left",	"CanEdit": 0},
	            {"Header": "우편번호",				"Type": "Text",	"Name": "LOC_ZIP",				"MinWidth": 80,		"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "주소",				"Type": "Text",	"Name": "LOC_ADDRA",			"MinWidth": 200,	"RelWidth": 1, 		"Align": "left",	"CanEdit": 0},
	            {"Header": "상세주소",				"Type": "Text",	"Name": "LOC_ADDRB",			"MinWidth": 120,	"RelWidth": 1, 		"Align": "left",	"CanEdit": 0},
	            {"Header": "결산일자",				"Type": "Text",	"Name": "ACCT_EDDT",			"MinWidth": 100,	"RelWidth": 1, 		"Align": "Center",	"CanEdit": 0},
	            {"Header": "자본금(원)",			"Type": "Int",	"Name": "FUNDTOTAL",			"MinWidth": 100,	"RelWidth": 1, 		"Align": "Right",	"CanEdit": 0, "Format": "#,###" },
	            {"Header": "매출액(원)",			"Type": "Int",	"Name": "SALES",				"MinWidth": 100,	"RelWidth": 1, 		"Align": "Right",	"CanEdit": 0, "Format": "#,###" },
            ],      

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				//초기 데이터 로딩
				init_1409p();
			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet_modal_1409p', // 생성할 시트의 id
				el: 'tb_cfms_supp_corp_veri_seq', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: SheetData_1409p // 생성될 시트의 정적데이터

			});
			// global 변수 선언
			//@ts-ignore
		},

		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet_modal_1409p.down2Excel({fileName: "지원기업검증이력_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
			
		},

	}
	
	
    async function init_1409p() {
		//@ts-ignore
		var row = sheet_modal.getFocusedRow();
		var vBIZ_NO = row["BIZ_NO"];
		
		const response:any = await CommonUtil.execute({
            url:"adm_1406_r007",
            data: {
				"BIZ_NO": vBIZ_NO,
			}
			
        })
    	.then((response: any) => {
			totalCnt_1409p = Object.keys(response.REC).length;
			setTotalRowCnt_1409p(totalCnt_1409p);

			SheetData_1409p = response.REC;
			// @ts-ignore
	        sheet_modal_1409p.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	        // @ts-ignore
	        sheet_modal_1409p.loadSearchData(SheetData_1409p);
					
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	 
    	
	}	
			        	

    async function onAfterOpen1409p() {
        ib_1409p.create();
        
		return () => {
      		// @ts-ignore
	    	IBSheet.sheet_modal_1409p.dispose();
	    }            
	
	}	
	
	async function onClose1410p() {
		setmodal1410pIsOpen(false);
		// @ts-ignore
		IBSheet.sheet_modal.dispose();
	}	
	        	
	async function onClose1411p() {
		setmodal1411pIsOpen(false);
		// @ts-ignore
		IBSheet.sheet_modal.dispose();
	}	

	async function onClose1415p() {
		setmodal1415pIsOpen(false);
		// @ts-ignore
		IBSheet.sheet_modal.dispose();
	}					

	async function onClose1408p() {
		setmodal1408pIsOpen(false);
		// @ts-ignore
		IBSheet.sheet_modal.dispose();
	}					

	async function onClose1409p() {
		setmodal1409pIsOpen(false);
		// @ts-ignore
		IBSheet.sheet_modal_1409p.dispose();
	}

    async function onAfterOpen1520p() {
		
	}

    async function onAfterOpen1521p() {

	}

    async function onAfterClose1520p() {
		console.log("inputFileValue.tbComFileMapngDetailList.length = " + inputFileValue.tbComFileMapngDetailList.length);
		if ( inputFileValue.tbComFileMapngDetailList.length > 0 ){
			for(var i = 0; inputFileValue.tbComFileMapngDetailList.length > i; i++){
				fileValue_tmp.putTbComFileMapngDetailList(inputFileValue.tbComFileMapngDetailList[i]);	
			}	
		}
		setFileInfoUploadList([]);
		setInputFileValue(new TbComFile())
		
	}

	async function onClose1520p() {
		setmodal1520pIsOpen(false);
		
	}	
	
	async function onClose1521p() {
		setmodal1521pIsOpen(false);
		setFileInfoUploadList_TAX([]);
	}	

 	const handleChange = (event) => {
		setJUDGE_CMT(event.target.value);
	};
	
	
	async function onClickPayReqJudge(value) {
		var AlertMsg = ''
		if ( value === 'B') AlertMsg = '접수하시겠습니까?'
		else if ( value === 'C') AlertMsg = '수정 요청하시겠습니까?'
		else if ( value === 'D') AlertMsg = '반려하시겠습니까?'
		else if ( value === 'F') AlertMsg = '최종 접수하시겠습니까?'
		
		var vJUDGE_CMT = ''
		if ( value === 'B') vJUDGE_CMT = '접수 되었습니다.'
		else if ( value === 'C') vJUDGE_CMT = JUDGE_CMT
		else if ( value === 'D') vJUDGE_CMT = JUDGE_CMT
		else if ( value === 'F') vJUDGE_CMT = '최종접수 되었습니다.'		
		
		var vEmail_YN = 'N'
		if(Email_YN){
			vEmail_YN = "Y"		
		}
		
		if(vJUDGE_CMT === ''){
			if ( value === 'C'){
				UIUtils.alert('수정의견을 작성해주세요.').then();
			}
			else if ( value === 'D'){
				UIUtils.alert('반려사유를 작성해주세요.').then();
			}
			return;
		}
		
		if(await UIUtils.confirm(AlertMsg)){
			
			if ( value === 'C' || value === 'D'){
				const response:any = await CommonUtil.execute({
		            url:"adm_1406_u004",
		            data: {
						"PAY_REQ_NO": receivedData.vPAY_REQ_NO,
						"PAY_REQ_STS_CD": value,
						"SUB_YN": "N",
						"JUDGE_CMT": vJUDGE_CMT,
						"EMAIL_YN" : vEmail_YN
					}
		        })
		    	.then((response: any) => {
					if(Email_YN){
						UIUtils.alert('이메일이 성공적으로 발송되었습니다.').then();	
					} else {
						UIUtils.alert('정상처리되었습니다.').then();
					}
					if ( value === 'C') setmodal1307pIsOpen(false)
					else if ( value === 'D') setmodal1211pIsOpen(false)
					setJUDGE_CMT('');
					setEmail_YN(false);
					initialize();
					
		    	}).catch((error) => {
		        	CommonUtil.showAxiosError(error);
		        	return;
		        	
	    		});
				
			} else {
				const response:any = await CommonUtil.execute({
		            url:"adm_1406_u003",
		            data: {
						"PAY_REQ_NO": receivedData.vPAY_REQ_NO,
						"PAY_REQ_STS_CD": value,
						"JUDGE_CMT": vJUDGE_CMT
					}
		        })
		    	.then((response: any) => {
					UIUtils.alert('정상처리되었습니다.').then();
					if ( value === 'C') setmodal1307pIsOpen(false)
					else if ( value === 'D') setmodal1211pIsOpen(false)
					setJUDGE_CMT('');
					setEmail_YN(false);
					initialize();
					
		    	}).catch((error) => {
		        	CommonUtil.showAxiosError(error);
		        	return;
		        	
		    	});
				
			}
    	}	 		
	}        	


	async function onClickSuppCorpVeri() {
		var count = 0;
		// @ts-ignore
		var rows = sheet_modal.getDataRows();
		
		for (var i = 0; i < rows.length; i++) {
			if ( rows[i]["chk"] ===  1 ){	
				count++;
			}
		}

		if( count === 0 ){
			UIUtils.alert('검증할 지원기업을 선택하여 주십시오.').then();
			return;
		}		
						
		if(await UIUtils.confirm('KED 연계를 통한 조회 및 검증을 하시겠습니까?')){
			// @ts-ignore
			var delItems: { BIZ_NO: string; }[] = [];
			// @ts-ignore
			var delItem: { BIZ_NO: string; } = {};
	
	    	// @ts-ignore
			var rows = sheet_modal.getDataRows();
			for (var i = 0; i < rows.length; i++) {
				// @ts-ignore
				if ( rows[i]["chk"] ===  1 ){
					console.log("Biz_no : " + rows[i]["BIZ_NO"]);	
			        delItem = {
			            BIZ_NO: rows[i]["BIZ_NO"],
			        };
			        delItems.push(delItem);
				}
		    				      	
		  	}
	
			const response:any = await CommonUtil.execute({
		        url:"adm_1406_c006",
		        data: {
					"REC" : delItems,
				}
		    })
			.then((response: any) => {
				UIUtils.alert('정상처리되었습니다.').then();
				init_1408p();
				
			}).catch((error) => {
		    	CommonUtil.showAxiosError(error);
		    	return;
		    	
			});
		}
 		
	} 
				
		
	async function onClickCloUpdate() {
		if(await UIUtils.confirm('종결처리하시겠습니까?')){
			const response:any = await CommonUtil.execute({
		        url:"adm_1406_u008",
		        data: {
					"PAY_REQ_NO" : receivedData.vPAY_REQ_NO,
				}
		    })
			.then((response: any) => {
				UIUtils.alert('정상처리되었습니다.').then();
				initialize();
				
			}).catch((error) => {
		    	CommonUtil.showAxiosError(error);
		    	return;
		    	
			});
 		}
	} 


	const handleButtonClick = () => {
		const url = 'https://www.nts.go.kr/'; // 여기에 접속할 URL을 입력하세요
		window.open(url, '_blank');
	};	


	useEffect(() => {
		if( receivedData !== undefined ){
			initialize();
				
		} else {
			onClickList();
			
		}
		
        return () => {
          // @ts-ignore
        }
        
    },[])

    		
	const onUploadComplete = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;

		let fileInfos : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_STATUS:string;
		}[] = [];

		let fileInfo : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_STATUS:string;
		};

		//파일등록 정보
		arrayNew?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				FILE_EXTSN:item.extension,
				FILE_STATUS:"ADD"
			}

			fileInfos.push(fileInfo);
		})

		//파일등록 정보
		arrayDel?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				FILE_EXTSN:item.extension,
				FILE_STATUS:"DEL"
			}

			fileInfos.push(fileInfo);
			
		})
		
		setFileInfoUploadList(fileInfos);

    }    
    
    const onCreationComplete = function (uploadID: string) {
		setUploadId(uploadID);
		console.log(uploadID);
    }


	async function OnPaySave() {
		if(await UIUtils.confirm(message.get("common.message.save.confirm", "저장하시겠습니까?"))){
			let fileInfos : {
				FILE_DETAIL_ID:string;
				ORGINL_FILE_NM:string;
				STRE_FILE_NM:string;
				FILE_SIZE:number;
				STRE_PATH:string;
				FILE_EXTSN:string;
				FILE_STATUS:string;
			}[] = [];
	
			let fileInfo : {
				FILE_DETAIL_ID:string;
				ORGINL_FILE_NM:string;
				STRE_FILE_NM:string;
				FILE_SIZE:number;
				STRE_PATH:string;
				FILE_EXTSN:string;
				FILE_STATUS:string;
			};

			if ( inputFileValue.tbComFileMapngDetailList.length > 0 ){
				fileInfo = {
					FILE_DETAIL_ID:String(inputFileValue.tbComFileMapngDetailList[0].getFileDetailId()),
					ORGINL_FILE_NM:String(inputFileValue.tbComFileMapngDetailList[0].getOrginlFileNm()),
					STRE_FILE_NM:String(inputFileValue.tbComFileMapngDetailList[0].getStreFileNm()),
					FILE_SIZE:Number(inputFileValue.tbComFileMapngDetailList[0].getFileSize()),
					STRE_PATH: "/" + String(inputFileValue.tbComFileMapngDetailList[0].getStrePath()).split("/").reverse().slice(1, 3).reverse().join("/") ,
					FILE_EXTSN:String(inputFileValue.tbComFileMapngDetailList[0].getFileExtsn()),
					FILE_STATUS:"ADD"
				}
				
				fileInfos.push(fileInfo);
			}	
			let param ={
				//"PAY_REQ_NO": receivedData.vPAY_REQ_NO,
				"FILE_ID": FILE_ID,               
				"FILE_INFO_LIST":fileInfos,
				"FILE_GB" : ""
			}

			const response:any = await CommonUtil.execute({
				url:'adm_1406_u009',
				data: param
			}).then(()=> {
				UIUtils.alert(message.get("common.message.save.success", "저장되었습니다."));
				if ( inputFileValue.tbComFileMapngDetailList.length > 0 ){
					for(var i = 0; inputFileValue.tbComFileMapngDetailList.length > i; i++){
						//fileValue_tmp.putTbComFileMapngDetailList(inputFileValue.tbComFileMapngDetailList[i]);
						const fileDetail = new TbComFileMapngDetail();
						fileDetail.setDwldId(String(inputFileValue.tbComFileMapngDetailList[i].getDwldId()));
						fileDetail.setFileDetailId(String(inputFileValue.tbComFileMapngDetailList[i].getFileDetailId()));
						fileDetail.setFilePolicy(String(inputFileValue.tbComFileMapngDetailList[i].getFilePolicy()));
						fileDetail.setFileRpstr(String(inputFileValue.tbComFileMapngDetailList[i].getFileRpstr()));
						fileDetail.setStrePath(String(inputFileValue.tbComFileMapngDetailList[i].getStrePath()));
						fileDetail.setStreFileNm(String(inputFileValue.tbComFileMapngDetailList[i].getStreFileNm()));
						fileDetail.setOrginlFileNm(String(inputFileValue.tbComFileMapngDetailList[i].getOrginlFileNm()));
						fileDetail.setFileExtsn(String(inputFileValue.tbComFileMapngDetailList[i].getFileExtsn()));
						fileDetail.setFileSize(Number(inputFileValue.tbComFileMapngDetailList[i].getFileSize()));
						 // @ts-ignore
						fileDetail.setRegistDt(inputFileValue.tbComFileMapngDetailList[i].getRegistDt());
						fileDetail.setRegistPsnNm(String(inputFileValue.tbComFileMapngDetailList[i].getRegistPsnNm()));
						fileValue_tmp.putTbComFileMapngDetailList(fileDetail);
							
					}	
				}

				
				setFileInfoUploadList([]);
				setInputFileValue(new TbComFile())
				//onClose1520p();
			}).catch(err => {
				CommonUtil.showAxiosError(err);
				return;
			});

		}
	}

	async function OnPayFormCheck() {
		if(await UIUtils.confirm(message.get("common.message.save.confirm", "저장하시겠습니까?"))){
			console.log("inputFileValue.tbComFileMapngDetailList.length = " + inputFileValue.tbComFileMapngDetailList.length);
			if ( inputFileValue.tbComFileMapngDetailList.length > 0 ){
				for(var i = 0; inputFileValue.tbComFileMapngDetailList.length > i; i++){
					fileValue_tmp.putTbComFileMapngDetailList(inputFileValue.tbComFileMapngDetailList[i]);	
				}	
			}
			
			setFormCheck(true);
			onFileUpload();

		}
	}
		
	const onFileUpload = () => {
		if(uploadId){
			window["RAONKUPLOAD"].Transfer(uploadId);
		}
	}

	async function FileSave(sendParam:any) {
		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'adm_1406_u009',
			data: sendParam
		}).then(()=> {
			UIUtils.alert(message.get("common.message.save.success", "저장되었습니다."));
			setFormCheck(false);
			onClose1520p();
		}).catch(err => {
			CommonUtil.showAxiosError(err);
			return;
		});
	
	}	

	useEffect(() => {
		if(fileInfoUploadList && FormCheck) {
			// 파일 업로드 성공
			let param ={
				//"PAY_REQ_NO": receivedData.vPAY_REQ_NO,
				"FILE_ID": FILE_ID,               
				"FILE_INFO_LIST":fileInfoUploadList,
				"FILE_GB" : ""
			}
			
			console.log("param : "+JSON.stringify(param));
			
			FileSave(param);

		} 
		
	}, [fileInfoUploadList])


    const onCreationComplete_TAX = function (uploadID: string) {
		setUploadId_TAX(uploadID);
		console.log(uploadID);
    }

	const onUploadComplete_TAX = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;

		let fileInfos : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_STATUS:string;
		}[] = [];

		let fileInfo : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_STATUS:string;
		};

		//파일등록 정보
		arrayNew?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				FILE_EXTSN:item.extension,
				FILE_STATUS:"ADD"
			}

			fileInfos.push(fileInfo);
		})

		//파일등록 정보
		arrayDel?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				FILE_EXTSN:item.extension,
				FILE_STATUS:"DEL"
			}

			fileInfos.push(fileInfo);
			
		})
		
		setFileInfoUploadList_TAX(fileInfos);
		
    } 

	async function OnTaxFormCheck() {
		if(await UIUtils.confirm(message.get("common.message.save.confirm", "저장하시겠습니까?"))){
			setTaxFormCheck(true);
			onFileUpload_TAX();

		}
	}

	const onFileUpload_TAX = () => {
		if(uploadId_TAX){
			window["RAONKUPLOAD"].Transfer(uploadId_TAX);
		}
	}


	async function FileSaveTax(sendParam:any) {
		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'adm_1406_u009',
			data: sendParam
		}).then(()=> {
			UIUtils.alert(message.get("common.message.save.success", "저장되었습니다."));
			setTaxFormCheck(false);
			onClose1521p();
		}).catch(err => {
			CommonUtil.showAxiosError(err);
			return;
		});
	
	}
	
	
	useEffect(() => {
		if(fileInfoUploadList_TAX && TaxFormCheck) {
			let param ={
				//"PAY_REQ_NO": receivedData.vPAY_REQ_NO,
				"FILE_ID": FILE_ID,               
				"FILE_INFO_LIST":fileInfoUploadList_TAX,
				"FILE_GB" : "TAX",
			}
			
			console.log("param_TAX : "+JSON.stringify(param));
			
			FileSaveTax(param);

		}
		
	}, [fileInfoUploadList_TAX])

    const inputFileValueTaxChanged = (value: TbComFile) => {
        console.log("inputFileValueTaxChanged", value)
        SetfileValue_TAX_tmp(value)
    }

    const inputFileValueChanged = (value: TbComFile) => {
        console.log("inputFileValueChanged = ", value)
        setInputFileValue(value)
        /*
			if ( value.tbComFileMapngDetailList.length > 0 ){
				for(var i = 0; value.tbComFileMapngDetailList.length > i; i++){
					console.log("value.tbComFileMapngDetailList[i] = ", value.tbComFileMapngDetailList[i].getOrginlFileNm());
					fileValue_tmp.putTbComFileMapngDetailList(value.tbComFileMapngDetailList[i]);	
				}	
			}
		*/
		for(var i = 0; inputFileValue.tbComFileMapngDetailList.length > i; i++){
			//fileValue_tmp.putTbComFileMapngDetailList(inputFileValue.tbComFileMapngDetailList[i]);
			const fileDetail = new TbComFileMapngDetail();
			fileDetail.setDwldId(String(inputFileValue.tbComFileMapngDetailList[i].getDwldId()));
			fileDetail.setFileDetailId(String(inputFileValue.tbComFileMapngDetailList[i].getFileDetailId()));
			fileDetail.setFilePolicy(String(inputFileValue.tbComFileMapngDetailList[i].getFilePolicy()));
			fileDetail.setFileRpstr(String(inputFileValue.tbComFileMapngDetailList[i].getFileRpstr()));
			fileDetail.setStrePath(String(inputFileValue.tbComFileMapngDetailList[i].getStrePath()));
			fileDetail.setStreFileNm(String(inputFileValue.tbComFileMapngDetailList[i].getStreFileNm()));
			fileDetail.setOrginlFileNm(String(inputFileValue.tbComFileMapngDetailList[i].getOrginlFileNm()));
			fileDetail.setFileExtsn(String(inputFileValue.tbComFileMapngDetailList[i].getFileExtsn()));
			fileDetail.setFileSize(Number(inputFileValue.tbComFileMapngDetailList[i].getFileSize()));
			 // @ts-ignore
			fileDetail.setRegistDt(inputFileValue.tbComFileMapngDetailList[i].getRegistDt());
			fileDetail.setRegistPsnNm(String(inputFileValue.tbComFileMapngDetailList[i].getRegistPsnNm()));
			fileValue_tmp.putTbComFileMapngDetailList(fileDetail);
				
		}	

    }
	
	if(!loadFinish)
		return (
			<PageLoading />
		)
	else	
	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={0} lnbD1Idx={3}  lnbD2Idx={2}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">지급 신청 상세</h1>
					
					<h3 className="section-title mb15">지급 신청 정보</h3>
					<form className="fo fo-col2 mb30" name="" action="" method="">
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">지급신청번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={PAY_REQ_NO_DISP} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">진행상태</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={PAY_REQ_STS_CD_DISP} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">지급 신청일</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={PAY_REQ_DATE} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">집행 완료일</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={PAY_COMPL_DATE} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">전자인증 여부</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={ELEC_APPR_YN} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">제출여부</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={SUB_YN_DISP} placeholder={''} readOnly={true} />
								</div>
							</div>							
						</div>
					</form>					
					
					<h3 className="section-title mb15">과제 신청 내용</h3>
					<form className="fo fo-col2 mb30" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">과제명</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={TSK_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">과제신청번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={TSK_REQ_NO_DISP} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">과제기간</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={TSK_DATE} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">사업분류</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={BIZ_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">기금사용용도</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={FUN_PUR_USE_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							 
							<div className="fo-item">
								<p className="fo-key">과제분야(대분류)</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={BIZ_KIND_NM1} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">과제분야(소분류)</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={BIZ_KIND_NM2} placeholder={''} readOnly={true} />
								</div>
							</div>
							
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">수행기관</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={PERF_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">지원금 지급방식</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={FORE_PAY_YN} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">총 지급신청금액</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8 w100p">
										<UIInput className={'hz-item hz-fg tf tf-md ta-right'} value={TOT_AMT} placeholder={''} readOnly={true} />
										<span className="hz-item tx tx-cp1 fc-pri">({TOT_AMT_D}만원)</span>
									</div>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">지원 기업수</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8 w100p">
										<UIInput className={'hz-item hz-fg tf tf-md'} value={SUPP_CORP_CNT} placeholder={''} readOnly={true} />
										{OPR_AMT_GIV_RATE === '0' && <Button color="gray-o" size="md" onClick={() => setmodal1408pIsOpen(true)}>지원기업 검증</Button>}
										{OPR_AMT_GIV_RATE === '0' && <Button color="gray-o" size="md" onClick={() => setmodal1410pIsOpen(true)}>지원기업 목록</Button>}
										{OPR_AMT_GIV_RATE !== '0' && <Button color="gray-o" size="md" onClick={() => setmodal1415pIsOpen(true)}>지원기업 목록</Button>}
									</div>
	
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">중소기업 지원금액</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8 w100p">
										<UIInput className={'hz-item hz-fg tf tf-md ta-right'} value={SUM_SUPP_CORP_AMT} placeholder={''} readOnly={true} />
										<span className="hz-item tx tx-cp1 fc-pri">({SUM_SUPP_CORP_AMT_D}만원)</span>
									</div>
								</div>
							</div>
							{PERF_CNT !== '0' && <div className="fo-item">
								<p className="fo-key">수행기관 수</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8 w100p">
										<UIInput className={'hz-item hz-fg tf tf-md'} value={PERF_CNT} placeholder={''} readOnly={true} />
										<Button color="gray-o" size="md" onClick={() => setmodal1411pIsOpen(true)}>수행기업 목록</Button>
									</div>
								</div>
							</div>}
							{PERF_CNT !== '0' && <div className="fo-item">
								<p className="fo-key">수행기관 지급금액</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8 w100p">
										<UIInput className={'hz-item hz-fg tf tf-md ta-right'} value={SUM_PERF_AMT} placeholder={''} readOnly={true} />
										<span className="hz-item tx tx-cp1 fc-pri">({SUM_PERF_AMT_D}만원)</span>
									</div>
								</div>
							</div>}
						</div>
					</form>					

					{TRAN_CONT_YN === 'Y' && <h3 className="section-title mb15">집행 내용</h3>}
					{TRAN_CONT_YN === 'Y' && <form id="AP_TRADE_MAST" name="AP_TRADE_MAST" className="fo fo-col2" action="" method="" hidden>
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">집행 기업수</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md'} value={NOR_CNT} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">집행 금액</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8 w100p">
										<UIInput className={'hz-item hz-fg tf tf-md ta-right'} value={NOR_AMT} placeholder={''} readOnly={true} />
										<span className="hz-item tx tx-cp1 fc-pri">({NOR_AMT_D}만원)</span>
									</div>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">미집행 기업수</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md'} value={NON_CNT} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">미집행 금액</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8 w100p">
										<UIInput className={'hz-item hz-fg tf tf-md ta-right'} value={NON_AMT} placeholder={''} readOnly={true} />
										<span className="hz-item tx tx-cp1 fc-pri">({NON_AMT_D}만원)</span>
									</div>
								</div>
							</div>
						</div>
					</form>}
					
					<h3 className="section-title mb15">과제개요 및 기대효과</h3>
					<form className="fo fo-col2 mb30" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">과제개요</p>
								<div className="fo-value">
									<div className="ta-view w100p">
										{formatNewLines(suppCont)}
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">정성효과</p>
								<div className="fo-value">
									<div className="ta-view w100p">
										{formatNewLines(exeEffDesc)}
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">기대효과</p>
								<div className="fo-value d-block">
									
									<form className="fo fo-col2 no-top-line mb0" name="" action="" method="">
										<div className="inner">
											<div className="fo-item">
												<p className="fo-key">매출액</p>
												<div className="fo-value">
													<UIInput className={'tf tf-md w100p'} value={qList.q1} placeholder={''} readOnly={true} />
												</div>
											</div>
											<div className="fo-item">
												<p className="fo-key">지식재산권</p>
												<div className="fo-value">
													<UIInput className={'tf tf-md w100p'} value={qList.q2} placeholder={''} readOnly={true} />
												</div>
											</div>
											<div className="fo-item">
												<p className="fo-key">일자리창출</p>
												<div className="fo-value">
													<UIInput className={'tf tf-md w100p'} value={qList.q3} placeholder={''} readOnly={true} />
												</div>
											</div>
											<div className="fo-item">
												<p className="fo-key">수출액</p>
												<div className="fo-value">
													<UIInput className={'tf tf-md w100p'} value={qList.q4} placeholder={''} readOnly={true} />
												</div>
											</div>
											<div className="fo-item">
												<p className="fo-key">판로처 확대</p>
												<div className="fo-value">
													<UIInput className={'tf tf-md w100p'} value={qList.q5} placeholder={''} readOnly={true} />
												</div>
											</div>
											<div className="fo-item">
												<p className="fo-key">신규참여 수탁기업 수</p>
												<div className="fo-value">
													<UIInput className={'tf tf-md w100p'} value={qList.q6} placeholder={''} readOnly={true} />
												</div>
											</div>
											<div className="fo-item">
												<p className="fo-key">신규 투자액</p>
												<div className="fo-value">
													<UIInput className={'tf tf-md w100p'} value={qList.q7} placeholder={''} readOnly={true} />
												</div>
											</div>
											<div className="fo-item">
												<p className="fo-key">신설 창업기업 수</p>
												<div className="fo-value">
													<UIInput className={'tf tf-md w100p'} value={qList.q8} placeholder={''} readOnly={true} />
												</div>
											</div>
											<div className="fo-item">
												<p className="fo-key">생산성 향상</p>
												<div className="fo-value">
													<UIInput className={'tf tf-md w100p'} value={qList.q9} placeholder={''} readOnly={true} />
												</div>
											</div>
											<div className="fo-item">
												<p className="fo-key">중소기업 체감도</p>
												<div className="fo-value">
													<UIInput className={'tf tf-md w100p'} value={qList.q10} placeholder={''} readOnly={true} />
												</div>
											</div>
											<div className="fo-item">
												<p className="fo-key">예상 구매액</p>
												<div className="fo-value">
													<UIInput className={'tf tf-md w100p'} value={qList.q11} placeholder={''} readOnly={true} />
												</div>
											</div>
											<div className="fo-item">
												<p className="fo-key">기타 성과1</p>
												<div className="fo-value">
													<UIInput className={'tf tf-md w100p'} value={qList.q12} placeholder={''} readOnly={true} />
												</div>
											</div>
											<div className="fo-item">
												<p className="fo-key">예상 판매액</p>
												<div className="fo-value">
													<UIInput className={'tf tf-md w100p'} value={qList.q13} placeholder={''} readOnly={true} />
												</div>
											</div>
											<div className="fo-item">
												<p className="fo-key">기타 성과2</p>
												<div className="fo-value">
													<UIInput className={'tf tf-md w100p'} value={qList.q14} placeholder={''} readOnly={true} />
												</div>
											</div>
										</div>
									</form>

								</div>
							</div>
						</div>
					</form>					

					<h3 className="section-title mb15">자료첨부</h3>
					<form className="fo fo-col2 mb30" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">지급 신청서</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8 w100p">
										<UI.FileDownloadSimpleMode value={fileValue_PRF} viewMode={"fund-download"}/>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3 req">
								<p className="fo-key">선지급 요청서(선지급시만)</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8 w100p">
										<UI.FileDownloadSimpleMode value={fileValue_APRF} viewMode={"fund-download"}/>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">세금계산서(내부용)</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8 w100p">
										<UI.FileDownloadSimpleMode value={fileValue_TAX} viewMode={"fund-download"}/>
										{/*<UIInput className={'hz-item hz-fg tf tf-md'} value={InputFileValue_TAX} placeholder={''} readOnly={true} />*/}
										<Button color="gray-o" size="md" onClick={handleButtonClick}>국세청바로가기</Button>
										{PAY_REQ_STS_CD !== 'G' && PAY_REQ_STS_CD !== 'H' && PAY_REQ_STS_CD !== 'A' && <Button color="gray-o" size="md" onClick={() => setmodal1521pIsOpen(true)}>문서첨부</Button>}
										{/*{PAY_REQ_STS_CD !== 'G' && PAY_REQ_STS_CD !== 'H' && PAY_REQ_STS_CD !== 'A' && <Button color="gray-o" size="md" onClick={() => setmodal1521pIsOpen(true)}>파일삭제</Button>}*/}
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<div className='w100p'>
									{/*<UI.FileUpload
									    value={fileValue}
										onCreationComplete={onCreationComplete}
										onUploadComplete={onUploadComplete}
										attrs={{
											ExtensionAllowOrLimit: "1",
											ImgPreView: "1", 
										}}
									/>*/}
									<UI.FileDownload value={fileValue} className={'w100p'}/>
		                            <UI.InputFile
		                                placeholder={'파일을 첨부해 주세요'}
		                                valueChanged={(value) => inputFileValueChanged(value)}
									/>
									<Button color='pri' size="md" onClick={OnPaySave}>저장</Button>
								</div>
							</div>							
						</div>
					</form>					

					<h3 className="section-title mb15">내부 검토사항</h3>
					{PAY_REQ_JUDGE_C.length > 0 && <div className="tb tb-narrow mb30"> 
						<table>
							<caption></caption>
							<colgroup>
								<col width="100px" />
								<col width="" />
								<col width="100px" />
							</colgroup>
							<thead>
								<tr>
									<th>순번</th>
									<th>수정요청내용</th>
									<th>담당자명</th>
								</tr>
							</thead>
							<tbody>
						        {PAY_REQ_JUDGE_C.map((row, index) => (
						          <tr key={index}>
						            <td>{row["SEQ"]}</td>
						            <td style={{ textAlign: 'left' }}>
						            	{formatNewLines(row["JUDGE_CMT"])}
						            </td>
						            <td>{row["PERSON_NM"]}</td>
						          </tr>
						        ))}
							</tbody>
						</table>
					</div>}					

					{PAY_REQ_JUDGE_C.length < 1 && <div className="tb tb-narrow mb30"> 
						<table>
							<caption></caption>
							<colgroup>
								<col width="100px" />
								<col width="" />
								<col width="100px" />
							</colgroup>
							<thead>
								<tr>
									<th>순번</th>
									<th>수정요청내용</th>
									<th>담당자명</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td colSpan={3}>
										<div className="nd">
											<p className="tx tx-cp2 fc-666">내역이 없습니다.</p>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>}				

					<h3 className="section-title mb15">반려사유</h3>
					{PAY_REQ_JUDGE_D.length > 0 && <div className="tb tb-narrow mb30"> 
						<table>
							<caption></caption>
							<colgroup>
								<col width="100px" />
								<col width="" />
								<col width="100px" />
							</colgroup>
							<thead>
								<tr>
									<th>순번</th>
									<th>반려사유</th>
									<th>담당자명</th>
								</tr>
							</thead>
							<tbody>
						        {PAY_REQ_JUDGE_D.map((row, index) => (
						          <tr key={index}>
						            <td>{row["SEQ"]}</td>
						            <td style={{ textAlign: 'left' }}>
						            	{formatNewLines(row["JUDGE_CMT"])}
						            </td>
						            <td>{row["PERSON_NM"]}</td>
						          </tr>
						        ))}
							</tbody>
						</table>
					</div>}					

					{PAY_REQ_JUDGE_D.length < 1 && <div className="tb tb-narrow mb30"> 
						<table>
							<caption></caption>
							<colgroup>
								<col width="100px" />
								<col width="" />
								<col width="100px" />
							</colgroup>
							<thead>
								<tr>
									<th>순번</th>
									<th>반려사유</th>
									<th>담당자명</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td colSpan={3}>
										<div className="nd">
											<p className="tx tx-cp2 fc-666">내역이 없습니다.</p>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>}				

					<h3 className="section-title mb15">심사 의견</h3>
					{PAY_REQ_JUDGE.length > 0 && <div className="tb tb-narrow mb30"> 
						<table>
							<caption></caption>
							<colgroup>
								<col width="100px" />
								<col width="100px" />
								<col width="200px" />
								<col width="" />
								<col width="100px" />
								<col width="200px" />
							</colgroup>
							<thead>
								<tr>
									<th>순번</th>
									<th>심사진행상태</th>
									<th>심사일시</th>
									<th>심사의견</th>
									<th>담당자명</th>
									<th>담당자 수정일시</th>
								</tr>
							</thead>
							<tbody>
						        {PAY_REQ_JUDGE.map((row, index) => (
						          <tr key={index}>
						            <td>{row["SEQ"]}</td>
						            <td>{row["PAY_REQ_STS_CD_NM"]}</td>
						            <td>{row["JUDGE_DATE"]}</td>
						            <td style={{ textAlign: 'left' }}>
						            	{formatNewLines(row["JUDGE_CMT"])}
						            </td>
						            <td>{row["PERSON_NM"]}</td>
						            <td>{row["MODI_DATE"]}</td>
						          </tr>
						        ))}							
							</tbody>
						</table>
					</div>}					

					{PAY_REQ_JUDGE.length < 1 && <div className="tb tb-narrow mb30"> 
						<table>
							<caption></caption>
							<colgroup>
								<col width="100px" />
								<col width="100px" />
								<col width="200px" />
								<col width="" />
								<col width="100px" />
								<col width="200px" />
							</colgroup>
							<thead>
								<tr>
									<th>순번</th>
									<th>심사진행상태</th>
									<th>심사일시</th>
									<th>심사의견</th>
									<th>담당자명</th>
									<th>담당자 수정일시</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td colSpan={6}>
										<div className="nd">
											<p className="tx tx-cp2 fc-666">내역이 없습니다.</p>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>}			
										
					<h3 className="section-title mb15">신청 기업 정보</h3>					
					<form className="fo fo-col2 mb30" name="" action="" method="">
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">기업명</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={CORP_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">법인사업자번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={CORP_REG_NO} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">사업자번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={BIZ_NO} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">담당자</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={PERSON_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">직위</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={POSI_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">부서</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={DEPT_NM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">이메일</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={EMAIL_ADRES} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">전화번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={OFC_TEL_NO} placeholder={''} readOnly={true} />
								</div>
							</div>
						</div>
					</form>


					<div className="hz-root hz-right hz-gap5">
						{SUB_YN === 'Y' && PAY_REQ_STS_CD === 'B' && <Button color="gray-o" size="sm" onClick={() => setmodal1520pIsOpen(true)}>문서첨부</Button>}
						{SUB_YN === 'Y' && (PAY_REQ_STS_CD === 'B' || PAY_REQ_STS_CD === 'C' ) && <Button color="gray-o" size="sm" onClick={() => onClickPayReqJudge('F')}>최종접수</Button>}
						{SUB_YN === 'Y' && (PAY_REQ_STS_CD === 'A' || PAY_REQ_STS_CD === 'B' || PAY_REQ_STS_CD === 'C') && <Button color="gray-o" size="sm" onClick={() => setmodal1211pIsOpen(true)}>반려</Button>}
						{SUB_YN === 'N' && PAY_REQ_STS_CD === 'A' && <Button color="gray-o" size="sm" onClick={() => setmodal1211pIsOpen(true)}>반려</Button>}
						{SUB_YN === 'N' && PAY_REQ_STS_CD === 'C' && <Button color="gray-o" size="sm" onClick={() => setmodal1211pIsOpen(true)}>반려</Button>}
						{SUB_YN === 'Y' && (PAY_REQ_STS_CD === 'B' || PAY_REQ_STS_CD === 'F' || PAY_REQ_STS_CD === 'C') &&<Button color="gray-o" size="sm" onClick={() => setmodal1307pIsOpen(true)}>수정요청</Button>}
						{SUB_YN === 'Y' && PAY_REQ_STS_CD === 'A' && <Button color="pri-o" size="sm" onClick={() => onClickPayReqJudge('B')}>접수</Button>}
						{PERF_CNT === '0' && PAY_REQ_STS_CD === 'G' && CLO_YN === 'N' && <Button color="gray-o" size="sm" onClick={onClickCloUpdate}>과제종결</Button>}
						<Button color="gray-o" size="sm" onClick={onClickList}>목록</Button>
					</div>
				</main>
			</div>
			{/* modal - 1408p*/}
			<ModalPopup
				open={modal1408pIsOpen}
				title="지원기업 검증"
				size="xlg"
				onClose={() => onClose1408p()}
				onAfterOpen={() => onAfterOpen1408p()}
			>
				<div className="modal-con">
					<p className="tx tx-cp1 mb10">한국기업데이터 연계하여 국내 사업자의 기업 개요 및 재무정보를 통해 기업 정보를 검증합니다. 단, 검증대상 기업의 재무자료, 관계사 관련 자료 등의 최신 데이터가 없는 경우 기업규모 판단내용이 부정확할 수 있습니다.</p>
					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
						</div>
						<div className="hz-root hz-gap5">
							<Button color="pri-o" size="sm"  onClick={() => onClickSuppCorpVeri()}>지원기업검증</Button>
							<Button color="gray-o" size="sm" onClick={()=> ib_1408p.exportData()}>다운로드</Button>
						</div>
					</div>
					
					<div className="ibsheet" id="tb_cfms_supp_corp_veri"></div>
				</div>
			</ModalPopup>
			{/* modal - 1409p*/}
			<ModalPopup
				open={modal1409pIsOpen}
				title="지원기업 검증 이력"
				size="xlg"
				onClose={() => onClose1409p()}
				onAfterOpen={() => onAfterOpen1409p()}
			>
				<div className="modal-con">
					<p className="tx tx-cp1 mb10">한국기업데이터 연계하여 국내 사업자의 기업 개요 및 재무정보를 통해 기업 정보를 검증합니다. 단, 검증대상 기업의 재무자료, 관계사 관련 자료 등의 최신 데이터가 없는 경우 기업규모 판단내용이 부정확할 수 있습니다.</p>
					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{TotalRowCnt_1409p}</em>건
						</div>
						<div className="hz-root hz-gap5">
							<Button color="gray-o" size="sm" onClick={()=> ib_1409p.exportData()}>다운로드</Button>
						</div>
					</div>
					
					<div className="ibsheet" id="tb_cfms_supp_corp_veri_seq"></div>
				</div>
			</ModalPopup>			
			{/* modal - 1410p*/}
			<ModalPopup
				open={modal1410pIsOpen}
				title="지원 기업 목록"
				size="xlg"
				onClose={() => onClose1410p()}
				onAfterOpen={() => onAfterOpen1410p()}
			>
				<div className="modal-con">
					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
						</div>
						<div className="hz-root hz-gap5">
							{/*<Button color="gray-o" size="sm">계좌미등록내역</Button>*/}
							<Button color="gray-o" size="sm" onClick={()=> ib_1410p.exportData()}>다운로드</Button>
						</div>
					</div>
					
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">지원 금액 합계(원)</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p ta-right'} value={TOT_AMT_M} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">집행 금액 합계(원)</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p ta-right fc-pri'} value={NOR_AMT_M} placeholder={''} readOnly={true} />
								</div>
							</div>
						</div>
					</form>
					<div className="ibsheet" id="tb_cfms_pay_req_amt_s"></div>
				</div>
			</ModalPopup>
			{/* modal - 1411p*/}
			<ModalPopup
				open={modal1411pIsOpen}
				title="수행 기업 목록"
				size="xlg"
				onClose={() => onClose1411p()}
				onAfterOpen={() => onAfterOpen1411p()}
			>
				<div className="modal-con">
					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
						</div>
						<div className="hz-root hz-gap5">
							{/*<Button color="gray-o" size="sm">계좌미등록내역</Button>*/}
							<Button color="gray-o" size="sm" onClick={()=> ib_1411p.exportData()}>다운로드</Button>
						</div>
					</div>
					
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">지원 금액 합계(원)</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p ta-right'} value={TOT_AMT_M} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">집행 금액 합계(원)</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p ta-right fc-pri'} value={NOR_AMT_M} placeholder={''} readOnly={true} />
								</div>
							</div>
						</div>
					</form>
					<div className="ibsheet" id="tb_cfms_pay_req_amt_p"></div>
				</div>	
			</ModalPopup>
			{/* modal - 1415p*/}
			<ModalPopup
				open={modal1415pIsOpen}
				title="지원기업목록(운영비)"
				size="xlg"
				onClose={() => onClose1415p()}
				onAfterOpen={() => onAfterOpen1415p()}
			>
				<div className="modal-con">
					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
						</div>
						<div className="hz-root hz-gap5">
							{/*<Button color="gray-o" size="sm">계좌미등록내역</Button>*/}
							<Button color="gray-o" size="sm" onClick={()=> ib_1415p.exportData()}>다운로드</Button>
						</div>
					</div>
					
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">지원 금액 합계(원)</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p ta-right'} value={TOT_AMT_M} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">집행 금액 합계(원)</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p ta-right fc-pri'} value={NOR_AMT_M} placeholder={''} readOnly={true} />
								</div>
							</div>
						</div>
					</form>
					<div className="ibsheet" id="tb_cfms_pay_req_amt"></div>
				</div>
			</ModalPopup>
			{/* modal - 1520p*/}
			<ModalPopup
				open={modal1520pIsOpen}
				title="문서첨부"
				size="lg"
				onClose={() => onClose1520p()}
				onAfterOpen={() => onAfterOpen1520p()}
				onAfterClose={() => onAfterClose1520p()}
			>
				<div className="modal-con">
					<div className="fo-item fo-m-1-5">
						<div className='w100p'>
                            <UI.InputFile
                                placeholder={'파일을 첨부해 주세요'}
                                valueChanged={(value) => inputFileValueChanged(value)}
							/>
							{/* 						
							<UI.FileUpload
							    //value={fileValuePop}
							    valueChanged={(value) => inputFileValueChanged(value)}
								onCreationComplete={onCreationComplete}
								onUploadComplete={onUploadComplete}
								attrs={{
									//MaxTotalFileCount: "1",
									//ExtensionAllowOrLimit: "1",
									ImgPreView: "1", 
								}}
							/>
							*/}
						</div>
					</div>					
				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md" onClick={() => setmodal1520pIsOpen(false)}>취소</Button>
						<Button color='pri' size="md" onClick={OnPaySave}>저장</Button>
					</div>
				</div>					
			</ModalPopup>
			{/* modal - 1521p*/}
			<ModalPopup
				open={modal1521pIsOpen}
				title="세금계산서첨부"
				size="lg"
				onClose={() => onClose1521p()}
				onAfterOpen={() => onAfterOpen1521p()}
			>
				<div className="modal-con">
					<div className="fo-item fo-m-1-5">
						<div className='w100p'>
                            {/* 
                            <UI.InputFile
                            	value={fileValue_TAX}
                                placeholder={'파일을 첨부해 주세요'}
                                valueChanged={(value) => inputFileValueTaxChanged(value)}
							/>
							*/}
							<UI.FileUpload
								//value={inputFileValue}
								valueChanged={(value) => inputFileValueTaxChanged(value)}
							    onCreationComplete={onCreationComplete_TAX}
								onUploadComplete={onUploadComplete_TAX}
								attrs={{
									MaxTotalFileCount: "1",
									ExtensionAllowOrLimit: "1",
									ImgPreView: "1"
								}}
							/>
							
						</div>
					</div>					
				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md" onClick={() => setmodal1521pIsOpen(false)}>취소</Button>
						<Button color='pri' size="md" onClick={OnTaxFormCheck}>저장</Button>
					</div>
				</div>					
			</ModalPopup>			
			{/* modal - 1211*/}
			<ModalPopup
				open={modal1211pIsOpen}
				title="반려 사유 입력"
				size="mid"
				onClose={() => setmodal1211pIsOpen(false)}
			>
				<div className="modal-con">
					<div className="ta h200">
						<textarea className="ta-ip" placeholder="반려사유를 입력하세요" value={JUDGE_CMT} onChange={handleChange}></textarea>
					</div>
				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="sm" onClick={() => setmodal1211pIsOpen(false)}>취소</Button>
						<Button color='pri' size="sm" onClick={() => onClickPayReqJudge('D')}>저장</Button>
					</div>
				</div>	
			</ModalPopup>			
			{/* modal - 1307p */}
			<ModalPopup
				open={modal1307pIsOpen}
				title="수정요청"
				size="sm"
				onClose={() => setmodal1307pIsOpen(false)}
			>
				<div className="modal-con">
					<div className="ta h130 w100p mb10">
						<textarea className="ta-ip" placeholder="수정의견을 입력하세요" value={JUDGE_CMT} onChange={handleChange}></textarea>
					</div>
					<label htmlFor="ch-1" className="hz-item ip-ch-label ip-ch-18">
						<UICheckbox valueChanged={(value) => setEmail_YN(value)}/>
						<span className="check"></span> 
						<span className="txt">출연기업의 신청자에게 안내메일이 발송됩니다.</span>
					</label>					

				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md" onClick={() => setmodal1307pIsOpen(false)}>취소</Button>
						<Button color='pri' size="md" onClick={() => onClickPayReqJudge('C')}>저장</Button>
					</div>
				</div>	
			</ModalPopup>				
		</PageContainer>
	);
}
export default ContentsContainer;


